import React from 'react';
import { productShortName } from '../data/offer';
export function Footer() {
  return <footer className="bg-surface text-muted" data-id="element-70" data-mp="3gezdb400vr15">
      <div className="h-1 w-full bg-primary shadow-[0_0_16px_rgb(var(--color-primary)/0.8)]" aria-hidden="true" data-id="element-71" data-mp="3ggtzeln15p6t" />
      <div className="mx-auto max-w-3xl px-4 py-8 text-center" data-id="element-72" data-mp="32pp5m06cfr4e">
        <p className="text-xs" data-id="element-73" data-mp="36qhh702ou83u">© 2026 {productShortName} — All rights reserved.</p>
      </div>
    </footer>;
}